import { Box } from '@mui/material'

import { Fee, Maybe, PaymentDetailFragment } from '@/clients/utoniq-core/schema'
import { BaseLayout, Head } from '@/components/layouts'
import { Loading } from '@/components/organisms'
import { MembershipJoinedModal } from '@/components/organisms/membership/membershipJoinedModal'
import { ArtistThemeProvider } from '@/components/styles'
import { useRouter, useTranslation } from '@/core'
import { Cell, Template } from '@/core/architecture'

import {
  ArtistMembershipPurchaseForm,
  ArtistMembershipPurchaseValues,
  MembershipPlan,
} from './ArtistMembershipPurchaseForm'

export * from './fragments'

export type State = {
  loading: boolean
  artistId: string
  paymentSource?: Maybe<PaymentDetailFragment>
  paymentFees?: Maybe<Fee[]>
  plans: MembershipPlan[]
  initialPlan?: ArtistMembershipPurchaseValues
  /** アーティスト毎に設定されているメンバーシップのキャリア決済加入が有効かどうか */
  enableMembershipCarrierPayment: boolean
  joined: boolean
}

/**
 * Action type.
 * use key name with 'on' prefix like onLogin.
 */
export type Action = {
  onSubmit: (values: ArtistMembershipPurchaseValues) => Promise<void>
}

export const ArtistMembershipPurchaseProceedTemplate: Template<State, Action> =
  ({ state, onSubmit }) => {
    const { t } = useTranslation('artistMembershipPurchaseProceed')
    const { routerNames } = useRouter()

    return (
      <ArtistThemeProvider artistId={state.artistId}>
        <Head title={routerNames.ArtistMembershipPurchaseProceed} />
        {state.joined ? (
          <MembershipJoinedModal artistId={state.artistId} />
        ) : (
          <BaseLayout
            header={{
              back: true,
              title: t('title', '支払い方法を選択'),
            }}
          >
            {state.loading ? (
              <LoadingCell />
            ) : (
              !!state.plans.length && (
                <ArtistMembershipPurchaseForm
                  plans={state.plans}
                  initialPlan={state?.initialPlan}
                  paymentSource={state.paymentSource}
                  paymentFees={state.paymentFees}
                  onSubmit={onSubmit}
                  enableMembershipCarrierPayment={
                    state.enableMembershipCarrierPayment
                  }
                />
              )
            )}
          </BaseLayout>
        )}
      </ArtistThemeProvider>
    )
  }

const LoadingCell: Cell = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '90dvh',
      }}
    >
      <Loading />
    </Box>
  )
}
